import { defineDirective } from '~/scripts/utils/alpine'

/**
 * x-reveal-text directive
 */
export default defineDirective(
  async (element, { expression }, { evaluateLater, cleanup }) => {
    const getOptions = evaluateLater<{ revert?: boolean }>(expression || '{}')

    const [{ gsap }, { ScrollTrigger }, { SplitText }] = await Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger'),
      import('gsap/SplitText'),
    ])

    gsap.registerPlugin(SplitText, ScrollTrigger)

    const mm = gsap.matchMedia()
    mm.add('(prefers-reduced-motion: no-preference)', () => {
      const split = SplitText.create(element, {
        type: 'words, lines',
        mask: 'lines',
      })

      gsap.from(split.words, {
        yPercent: 100,
        stagger: {
          amount: 0.5,
        },
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          once: true,
        },
        onStart: () => {
          gsap.set(element, { visibility: 'visible' })
        },
        onComplete: () => {
          getOptions((options) => {
            if (options.revert !== false) {
              split.revert()
            }
          })
        },
      })
    })

    cleanup(() => {
      mm.revert()
    })
  },
)
